import { css } from 'emotion';

import { fonts } from '../../../../styles';

const dataColumn = (minWidth: string, maxWidth: string = minWidth) => css`
  max-width: ${maxWidth};
  min-width: ${minWidth};
  white-space: nowrap;
`;

const plateCell = css`
  div {
    margin: 0 auto;
  }
`;

const searchField = css`
  width: 350px;
  margin-right: 20px;
`;

const tablePlaceholder = css`
  font-weight: 300;
  font-size: ${fonts.size.small};
`;

const weightedText = css`
  font-weight: ${fonts.weight.medium};
`;

const tableStyle = css`
  table-layout: fixed;
`;

const icon = css`
  margin-right: 10px;
`;

const row = css`
  display: flex;
  margin: 20px 0px 20px 20px;
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 0;
  padding: 70px 0 40px;
`;

export default {
  dataColumn,
  plateCell,
  tablePlaceholder,
  weightedText,
  tableStyle,
  searchField,
  icon,
  row,
  placeholder,
};
